import React from "react";
import S from './Contacts.module.scss';
import {MapComponent} from "../../shared/components/mapComponent";
import vk from "../../shared/assets/images/vk2.png";

interface IProps {
    contacts: any,
}

export const Contacts = ({contacts}: IProps) => {
    return (
        <div>
            <div className={S.content}>
                <div className={S.title}>КОНТАКТЫ</div>
            </div>
            <div className={S.divMap}>
                <div className={S.cardDiv}>
                    <div className={S.infoDiv}>
                        <div className={contacts === 5 ? S.titleInfoLogistics : S.titleInfo}>МЕСТО ПРОВЕДЕНИЯ:</div>
                        <div className={S.textInfo}>
                            <span>{contacts === 1 ? "«ДВОРЕЦ МЕТАЛЛУРГОВ»" : "БО «ТОРОВО»"}</span><br/>
                            г.Череповец
                        </div>
                    </div>
                    <div className={S.infoDiv}>
                        <div className={contacts === 5 ? S.titleInfoLogistics : S.titleInfo}>ДАТА ПРОВЕДЕНИЯ:</div>
                        <div className={S.textInfo}>
                            {contacts === 1 ? "18-20 ноября 2026г." : "9-11 декабря"}
                        </div>
                    </div>
                    <div className={S.infoDiv}>
                        <div className={contacts === 5 ? S.titleInfoLogistics : S.titleInfo}>ТЕЛЕФОН:</div>
                        <a href="tel:+79220197166" className={S.aTextInfo}>
                            +7 (922) 019-71-66
                        </a>
                    </div>
                    <div className={S.infoDiv}>
                        <div className={contacts === 5 ? S.titleInfoLogistics : S.titleInfo}>E-MAIL:</div>
                        <a href="mailto:info@evoforum.ru" className={S.aTextInfo}>
                            info@evoforum.ru
                        </a>
                    </div>
                    <div className={S.infoDiv}>
                        <img src={vk} alt="vk"/>
                        <a href="https://vk.ru/club241247865" target="_blank" rel="noreferrer" className={S.aTextInfo}>
                            vk.ru/evoforum
                        </a>
                    </div>
                </div>
                <MapComponent contacts={contacts}/>
            </div>
        </div>
    );
}